import {
  CapabilityKey,
  getDefaultCapabilities
} from '../../../../../../components/generic/teamCapabilities'
import type { WizardRole } from '../../../../../../components/generic/teamCapabilities/types'
import type { EditPermissionsData } from './types'

// Compute the panel's capabilities when the selected role changes.
//
// Toggles reset to the new role's defaults, EXCEPT medication, which preserves
// the user's previous choice — but only when the new role actually offers a
// medication toggle. A role with no add-on toggles (Audit View, IT & Security)
// has no medication capability and an empty defaults map; carrying the previous
// medication value there would persist a setting the user can no longer see or
// change, and Save would still send it. So in that case we return the (empty)
// defaults and let medication clear.
export const capabilitiesForRoleChange = (
  previous: EditPermissionsData['capabilities'],
  role: WizardRole
): EditPermissionsData['capabilities'] => {
  const defaults = getDefaultCapabilities(role)

  if (!(CapabilityKey.MedicationManagement in defaults)) {
    return defaults
  }

  return {
    ...defaults,
    [CapabilityKey.MedicationManagement]:
      previous[CapabilityKey.MedicationManagement] ??
      defaults[CapabilityKey.MedicationManagement]
  }
}
